export interface ResendInviteResponse {
  success: boolean;
  message: string;
  data?: {
    user?: {
      userType?: string;
    };
  };
  error?: any;
}

const hostname =  window.location.hostname;

export async function resendInvite(userEmail: string): Promise<ResendInviteResponse> {
  let baseurl = '';
  
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  const res = await fetch(`${baseurl}/api/candidate-dashboard/resend-invite`, {
    method: 'POST',
    headers: { 
      'Accept': 'application/json', 
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ userEmail }),
  });

  if (!res.ok) throw new Error('Failed to resend invitation');
  return res.json();
}